/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TrashIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TrashIcon({
  children,
  viewPath = "/DesignSystem/Svgs/TrashIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 64,
  height = 64,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#363636"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TrashIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 64 64"
 style={{'--as-1-Z1iSClH': alignSelf,'--mt-2-Z1iSClH': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1iSClH': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1iSClH': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1iSClH': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1iSClH': opacity,'--w-10-Z1iSClH': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1iSClH': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1iSClH': isAnimated ? animation : "none",'--sd-8-Z1iSClH': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1iSClH': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TrashIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M52.2 18.8H11.8M27.4 44.8V26.7M36.6 44.8V26.7M26.4 12.8h11.2M45.9 22.8v22.4c0 3.2-2.6 5.8-5.8 5.8H23.9c-3.2 0-5.8-2.6-5.8-5.8V22.8"
 style={{'--f-12-Z1iSClH': fill,'--s-13-Z1iSClH': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}